export const CII_RATINGS = ["A", "B", "C", "D", "E"]

// A (best) → E (worst), per the design spec's traffic-light scale.
export const CII_RATING_COLORS = {
  A: "#2e7d32",
  B: "#7cb342",
  C: "#f9a825",
  D: "#ef6c00",
  E: "#d64545",
}

// JS twin of core's consumption_curve gate: at least 2 rows with finite
// non-negative knots/consumption (deduped by knots), else core rejects
// cii / fuel_optimisation with a 422.
export function hasUsableConsumptionCurve(rows) {
  const knotsSeen = new Set()
  for (const row of rows ?? []) {
    const knots = Number(row?.knots)
    const consumption = Number(row?.consumption)
    if (
      Number.isFinite(knots) &&
      knots >= 0 &&
      Number.isFinite(consumption) &&
      consumption >= 0
    ) {
      knotsSeen.add(knots)
    }
  }
  return knotsSeen.size >= 2
}

// Translate the planner's fuel state into buildCoreRequest params.
// Empty/partial inputs yield null so the feature is simply not sent. The CII
// block is not built here: core derives it from the vessel master data
// (vessel.id in the request) for planner, import and recalc alike.
export function buildFuelRequestParams({
  bunkerPrices,
  currentDraft,
  fuelOptimisation,
  consumptionProfile,
}) {
  const usd = Number(bunkerPrices?.usdPerTon)
  const eca = Number(bunkerPrices?.ecaUsdPerTon)
  const consumptionPrices =
    usd > 0
      ? { usd_per_ton: usd, ...(eca > 0 ? { eca_usd_per_ton: eca } : {}) }
      : null
  const usableCurve = hasUsableConsumptionCurve(consumptionProfile)

  return {
    currentDraft,
    consumptionPrices,
    fuelOptimisation: !!fuelOptimisation && !!consumptionPrices && usableCurve,
  }
}
